// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2OxTL","containerItemsCenter":"Skeleton_containerItemsCenter__s-d5c"};